<div class="edit-food-bottomsheet-container">
  <div class="edit-food-bottomsheet-top" (swipedown)="swipe($event.type)">
    <div class="edit-food-bottomsheet-top-indicator"></div>
  </div>
  <div *ngIf="!isCustome">
    <div class="edit-food-bottomsheet-name" id="edit-food-name">
      {{ data.food.foodModel.name }}
    </div>
    <!-- <div
    *ngIf="!calorie"
    class="edit-food-bottomsheet-calorie"
    (click)="openDetail()"
    id="edit-food-calorie"
  >
    ۰ کالری
  </div> -->
    <div
      *ngIf="convertStringToNumber(amount) && gram === -1"
      class="edit-food-bottomsheet-calorie"
      (click)="openDetail()"
      id="edit-food-calorie"
    >
      {{ calorie.toFixed(0) }} کالری
    </div>
    <div
      *ngIf="convertStringToNumber(amount) && gram !== -1"
      class="edit-food-bottomsheet-calorie"
      (click)="openDetail()"
      id="edit-food-calorie"
    >
      {{ calorie.toFixed(0) }} کالری ({{ gram.toFixed(0) }} گرم)
    </div>
    <div class="edit-food-bottomsheet-input-holder">
      <input
        type="text"
        inputmode="decimal"
        [(ngModel)]="amount"
        maxlength="5"
        (input)="calculateCalorie()"
        placeholder="مقدار"
      />
      <!-- <img src="assets/plan/down-arrow-blue.svg"> -->
      <mat-select
        class="edit-food-bottomsheet-select"
        [(ngModel)]="selectedRatio"
        name="ratio"
        (selectionChange)="onRatioChange()"
      >
        <mat-option
          class="edit-food-bottomsheet-option"
          *ngFor="let ratio of ratios"
          [value]="ratio"
        >
          {{ ratio }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div *ngIf="isCustome">
    <div class="edit-food-bottomsheet-name custome-title" id="edit-food-name">
      {{ data.food.title }}
    </div>
    <div class="input-wrapper">
      <input type="tel" [(ngModel)]="qcalorie" (input)="calculateCalorie()" />
      <div class="unit">کالری</div>
    </div>
  </div>
  <mat-spinner *ngIf="showLoading" class="spinner"></mat-spinner>
  <div *ngIf="showLoading" class="spinner-holder"></div>

  <div class="Buttons">
    <div
      *ngIf="!showLoading"
      [ngClass]="{
        blue: isButtonActive
      }"
      class="success"
      (click)="editFoodCheck()"
    >
      ثبت
    </div>
    <div class="cancel" (click)="removeFoodCheck()">حذف</div>
  </div>
</div>
